<div class="text-center s-p-3 border empty-data-card">
  <img class="s-h-50" src="/assets/images/empty-48.svg" [alt]="'COMMON.NO_DATA' | translate" />
  <h2 class="c-card-subtitle">
    {{ 'COMMON.NO_DATA' | translate }}
  </h2>
</div>
